export const mapImageURL = (arr) => {
  return arr.map((item) => {
    const mappedItem = {
      ...item,
      image: require("../app/assets/" + item.image),
    };
    if (item.themePattern) {
      mappedItem.themePattern = require("../app/assets/" + item.themePattern);
    }
    return mappedItem;
  });
};
